// Contentful Entry IDs
export const CERTIFICATION_MESSAGE_ENTRY_ID = '55Q1dQZKUzoyOB0TgVZSr8';
export const COMPLIANCE_REMINDER_ENTRY_ID = '7CkSJrNRbvR3FBrijBY6ag';

// Default Values for Production
export const DEFAULT_TRANSMITTER_CONTROL_CODE = 'PBSA0301';

// Default Values for Sandbox
//export const DEFAULT_TRANSMITTER_CONTROL_CODE = 'TBSATEST';
